import type { ChatMessage, ChatMessagesResponse } from './api';

// HTTP responses and publications share stable message IDs. Merge at completion
// time so an older in-flight history request cannot remove a confirmed send.
export function mergeRoomChat(room: string, previous: ChatMessagesResponse | undefined, incoming: unknown[]): ChatMessagesResponse {
  const messages = new Map<string, ChatMessage>();
  for (const value of [...(previous?.messages || []), ...incoming]) {
    if (!value || typeof value !== 'object') continue;
    const message = value as ChatMessage;
    if (message.id == null || message.room_id !== room) continue;
    if (message.type !== 'text' && message.type !== 'voice') continue;
    messages.set(String(message.id), { ...messages.get(String(message.id)), ...message });
  }
  return {
    room_id: room,
    messages: [...messages.values()].sort((a, b) => Number(a.ts || 0) - Number(b.ts || 0)).slice(-50),
  };
}
